/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import BaseProjection from '@bingads-webui-component-legacy/grid/projection/base';
import schema_properties from '@bingads-webui-component-legacy/grid/schema/properties';
import Response from '@bingads-webui-component-legacy/grid/model/response';
var Model = BaseProjection.extend({
  defaults: {
    orderby: [],
    select: [],
    'column.sortable': {}
  },
  name: 'memory-sort',
  update: function (options) {
    if (Model.__super__.update.call(this, options)) {
      var model = this.src.data, order = _.chain(this.get('orderby')).first().pairs().first().value();
      var order_key = _.first(order), order_dir = _.last(order);
      var value = model.get('value');
      var sortFunc = this.get('column.sortable')[order_key];
      if (order_key) {
        if (_.isFunction(sortFunc)) {
          value = sortFunc(value, order_dir);
        } else {
          value = _.sortBy(value, order_key);
          if (order_dir == -1) {
            value = value.reverse();
          }
        }
      }
      var select = this.get('select');
      if (!_.size(select)) {
        select = schema_properties.from(value);
      }
      this.patch({
        value: value,
        select: select
      });
    } else {}
  }
});
export default Model;

